export  const TripDetailConstant = {
    TRIP_DETAIL_SAGA: "TRIP_DETAIL_SAGA",
    TRIP_DETAIL_REQUEST: "TRIP_DETAIL_REQUEST",
    TRIP_DETAIL_RESPONSE: "TRIP_DETAIL_RESPONSE",
    TRIP_DETAIL_API: "/trip/details",
  
   
  };
  